import { useContext } from 'react'

import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiDeleteFetcher } from '@/common/api/fetcher'
import {
  DeleteWidgetPageResponse,
  DeleteWidgetPageVars,
  GetWidgetPageResponse,
  GetWidgetPageVars,
  ListWidgetPagesResponse,
  ListWidgetPagesVars,
  WidgetPageApiPath
} from '@/common/api/params/widgetPage'
import { useShowDeletedToast } from '@/common/app/toast'
import { WidgetPage } from '@/common/model/recommend/widgetPage'

import { DeleteDialogContext } from '@/components/container/modal/dialog/delete/DeleteDialogProvider'

export const useWidgetPageGetApi = ({
  siteId,
  widgetPageId
}: {
  siteId: number
  widgetPageId: number
}) => {
  return useSWR<GetWidgetPageResponse, Response, [string, GetWidgetPageVars]>([
    WidgetPageApiPath.GET_WIDGET_PAGE,
    { site_id: siteId, widget_page_id: widgetPageId }
  ])
}

export const useWidgetPageListApi = (vars: ListWidgetPagesVars) => {
  return useSWR<ListWidgetPagesResponse, Response, [string, ListWidgetPagesVars]>([
    WidgetPageApiPath.LIST_WIDGET_PAGES,
    vars
  ])
}

export const useWidgetPageDeleteApi = (widgetPage: WidgetPage, onSuccess: () => void) => {
  const showDeleted = useShowDeletedToast()
  const { showModal, hide } = useContext(DeleteDialogContext)

  const { trigger } = useCallMutation<DeleteWidgetPageResponse, DeleteWidgetPageVars>(
    WidgetPageApiPath.DELETE_WIDGET_PAGE,
    {
      onSuccess: () => {
        showDeleted(widgetPage.name)
        hide()
        onSuccess()
      }
    },
    apiDeleteFetcher
  )

  const onClickDelete = () => {
    showModal({
      name: widgetPage.name,
      onClickDelete: () =>
        trigger({ site_id: widgetPage.site_id, widget_page_id: widgetPage.id }).then()
    })
  }
  return { onClickDelete }
}
